import { Nutshell } from '@nutshell/core';

/**
 * Default settings
 */
Nutshell.options.ServerRequest.baseurl = window.location.href;
Nutshell.options.ServerRequest.secure = false;
Nutshell.options.ServerRequest.peanuts = false;
Nutshell.options.ServerRequest.status = 'header';
Nutshell.options.ServerRequest.headers = {
	'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
};

Nutshell.options.Validator.message.parent = true;
Nutshell.options.Validator.custom.patterns.zipcode = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
Nutshell.options.Validator.custom.patterns.password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\# ])[A-Za-z\d@$!%*?&\# ]{8,}$/;

/**
 * Vue Application Config
 */
export const AppConfig = {
	mount: '#application'
}

/**
 * Vue Router Config
 */
export const RouterConfig = {
	mode: 'history'
}

/**
 * Export all configs
 */
export default {
	App: AppConfig,
	Router: RouterConfig
}
